import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-physical-cards',
  templateUrl: './physical-cards.component.html',
  styleUrls: ['./physical-cards.component.scss']
})
export class PhysicalCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/physical-cards/physical-cards/physical-cards.component.ts